import React, { useMemo } from 'react'
import { useCurrentOrg } from 'auth/hooks'
import { timezones } from 'civic-champs-shared/helpers/timezones'
import { Organization } from 'organization/types'
import { FormModal } from 'components/FormModal'
import OrganizationDetailsScreen from 'volunteering/organizations/components/OrganizationDetailsScreen'

export default function OrganizationDataModal(props: {
  showing: boolean
  complete: (...props: any) => Promise<any>
  cancel: () => Promise<any>
  organization?: Organization
}) {
  const { organization, showing, cancel, complete } = props
  const currOrg = useCurrentOrg()
  const org = organization ?? currOrg
  const initialValues = useMemo(
    () => ({
      name: org.name,
      website: org.website,
      timeZone: timezones.find(({ value }) => value === org.timeZone),
    }),
    [org],
  )

  return (
    <FormModal id={'trip-prompt'} showing={showing} close={cancel} title="Edit Organization Details">
      <OrganizationDetailsScreen
        formData={initialValues as any}
        buttonsProps={{
          nextButton: { onClick: complete, caption: 'Save' },
          backButton: { onClick: cancel, caption: 'Cancel' },
        }}
      />
    </FormModal>
  )
}
